export const STATUS_TINT: Record<string, string> = {
  'bg-cyan-2': 'bg-cyan-2/[0.14]',
  'bg-blue-2': 'bg-blue-2/[0.14]',
  'bg-navy-2': 'bg-navy-2/[0.14]',
  'bg-yellow-3': 'bg-yellow-3/[0.14]',
  'bg-green-2': 'bg-green-2/[0.14]',
  'bg-orange-2': 'bg-orange-2/[0.14]',
  'bg-pink-3': 'bg-pink-3/[0.14]',
};
